<template>
    <div class="app-drawer" v-if="menuOpen">
        <div class="fixed inset-0 z-10000" @click="closeMenu()"></div>
        <div
            class="fixed inset-y-0 right-0 z-10000 w-full overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
        >
            <div class="flex items-center justify-between px-6 pt-6 pb-1">
                <div class="-m-1.5 p-1.5 text-2xl font-bold text-gray-900">
                    {{ $config.public.siteName }}
                </div>
                <button type="button" class="-m-2.5 rounded-md p-2.5 text-zinc-900" @click="closeMenu()">
                    <span class="sr-only">Close menu</span>
                    <svg
                        class="h-7 w-7"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="mt-6 px-6 flow-root">
                <div class="-my-6 divide-y divide-gray-500/10" @click="closeMenu()">
                    <div class="space-y-2 py-6">
                        <button-drawer buttonText="Home" buttonRoute="/"></button-drawer>
                        <button-drawer buttonText="Subscribe" buttonRoute="/subscribe"></button-drawer>
                        <button-drawer buttonText="Blog" buttonRoute="/blog"></button-drawer>
                        <button-drawer v-if="!isLoggedIn" buttonText="Login" buttonRoute="/login"></button-drawer>
                        <button-drawer v-if="!isLoggedIn" buttonText="Signup" buttonRoute="/signup"></button-drawer>
                        <button-drawer buttonText="Contact" buttonRoute="/contact"></button-drawer>
                        <button-drawer
                            v-if="isLoggedIn"
                            buttonText="Messages"
                            buttonRoute="/messages"
                            :buttonBadge="unreadCount"
                        ></button-drawer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'AppDrawer',
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        ...mapState(useStoreHeader, {
            menuOpen: 'menuOpen',
        }),
        ...mapState(useStoreThreadsUnread, {
            unreadCount: 'unreadCount',
        }),
    },
    methods: {
        ...mapActions(useStoreHeader, {
            closeMenu: 'closeMenu',
        }),
    },
    watch: {
        $route() {
            this.closeMenu();
        },
    },
    beforeUnmount() {
        this.closeMenu();
    },
};
</script>
